// extracted by mini-css-extract-plugin
export default {"MONTH":"I6SHQX","month":"I6SHQX","DAY":"W8ltmf","day":"W8ltmf","YEAR":"r4F8yJ","year":"r4F8yJ","fields":"jb2S4Z","mobile":"_X8078"};